<template>
  <div class="rotContainer">
    <div class="menuSideBar">
      <Menu :menu="menuItems" @menuClicked="menuClicked" />
    </div>

    <div class="mainContent">
      <div class="filterBar">
        <div class="statusFilterContainer">
          <div
            class="statusFilterButton"
            :style="{ 'background-color': showPending ? 'rgb(255, 255, 153)' : 'rgb(136, 136, 136)' }"
            @click="toggleStatus('pending')"
          >
            <div class="statusIcon"
              ><img
                :src="
                  showPending ?
                    'https://dsmlib.logistics.systems/Icons/ClockBlack.png'
                  : 'https://dsmlib.logistics.systems/Icons/ClockWhite.png'
                "
            /></div>
            <div
              class="statusLabel"
              :style="{
                'text-decoration': showPending ? 'initial' : 'line-through',
                color: showPending ? 'black' : 'white',
              }"
              >Pending</div
            >
            <div
              class="statusCounter"
              :style="{
                'text-decoration': showPending ? 'initial' : 'line-through',
                color: showPending ? 'black' : 'white',
              }"
              >{{ pendingeROTCount }}</div
            >
          </div>
          <div
            class="statusFilterButton"
            :style="{ 'background-color': showSent ? 'rgb(231, 150, 3)' : 'rgb(136, 136, 136)' }"
            @click="toggleStatus('sent')"
          >
            <div class="statusIcon"
              ><img
                :src="
                  showSent ?
                    'https://dsmlib.logistics.systems/Icons/SendBlack.png'
                  : 'https://dsmlib.logistics.systems/Icons/SendWhite.png'
                "
            /></div>
            <div
              class="statusLabel"
              :style="{ 'text-decoration': showSent ? 'initial' : 'line-through', color: showSent ? 'black' : 'white' }"
              >Sent</div
            >
            <div
              class="statusCounter"
              :style="{ 'text-decoration': showSent ? 'initial' : 'line-through', color: showSent ? 'black' : 'white' }"
              >{{ senteROTCount }}</div
            >
          </div>
          <div
            class="statusFilterButton"
            :style="{ 'background-color': showAccepted ? 'rgb(121, 210, 121)' : 'rgb(136, 136, 136)' }"
            @click="toggleStatus('accepted')"
          >
            <div class="statusIcon"
              ><img
                :src="
                  showAccepted ?
                    'https://dsmlib.logistics.systems/Icons/CheckmarkBlack.png'
                  : 'https://dsmlib.logistics.systems/Icons/CheckmarkWhite.png'
                "
            /></div>
            <div
              class="statusLabel"
              :style="{
                'text-decoration': showAccepted ? 'initial' : 'line-through',
                color: showAccepted ? 'black' : 'white',
              }"
              >Accepted</div
            >
            <div
              class="statusCounter"
              :style="{
                'text-decoration': showAccepted ? 'initial' : 'line-through',
                color: showAccepted ? 'black' : 'white',
              }"
              >{{ acceptedeROTCount }}</div
            >
          </div>
          <div
            class="statusFilterButton"
            :style="{ 'background-color': showRejected ? 'rgb(255, 77, 77)' : 'rgb(136, 136, 136)' }"
            @click="toggleStatus('rejected')"
          >
            <div class="statusIcon"
              ><img
                :src="
                  showRejected ?
                    'https://dsmlib.logistics.systems/Icons/CrossmarkBlack.png'
                  : 'https://dsmlib.logistics.systems/Icons/CrossmarkWhite.png'
                "
            /></div>
            <div
              class="statusLabel"
              :style="{
                'text-decoration': showRejected ? 'initial' : 'line-through',
                color: showRejected ? 'black' : 'white',
              }"
              >Rejected</div
            >
            <div
              class="statusCounter"
              :style="{
                'text-decoration': showRejected ? 'initial' : 'line-through',
                color: showRejected ? 'black' : 'white',
              }"
              >{{ rejectedeROTCount }}</div
            >
          </div>
        </div>

        <div class="generalFilterContainer">
          <div class="generalFilterContent" style="text-align: right">{{ filtersSummary }}</div>
          <div class="generalFilterContent">
            <button @click="showChangeFilterPopup = !showChangeFilterPopup">Change Filter</button>
            <div v-if="showChangeFilterPopup" class="changeFilterPopup">
              <div class="changeFilterPopupItemContainer">
                <div class="changeFilterPopupItemFields" style="flex-direction: row">
                  <Dropdown
                    placeholder="Haulier Code"
                    :items="haulierFilterItems"
                    itemKey="Haulier Code"
                    :selectedObject.sync="selectedHaulier"
                    :isRequired="true"
                    :errorMessage.sync="haulierFilterErrorMessage"
                    textAlign="left"
                  />
                </div>
              </div>
              <div class="changeFilterPopupItemContainer">
                <CheckBox
                  class="changeFilterPopupItemCheckbox"
                  title="Date"
                  :isChecked="dateFilterChecked"
                  @checkBoxClicked="dateFilterChecked = !dateFilterChecked"
                />
                <div class="changeFilterPopupItemFields" style="flex-direction: row">
                  <DateTimePicker
                    placeholder="Start"
                    :showTime="false"
                    :value.sync="dateFilterStart"
                    :maxDate="dateFilterEnd"
                    :isDisabled="!dateFilterChecked"
                    :errorMessage.sync="dateFilterStartErrorMessage"
                  />
                  <DateTimePicker
                    placeholder="End"
                    :showTime="false"
                    :value.sync="dateFilterEnd"
                    :minDate="dateFilterStart"
                    :isDisabled="!dateFilterChecked"
                    :errorMessage.sync="dateFilterEndErrorMessage"
                  />
                </div>
              </div>
              <div class="changeFilterPopupItemContainer">
                <CheckBox
                  class="changeFilterPopupItemCheckbox"
                  title="Search"
                  :isChecked="searchFilterChecked"
                  @checkBoxClicked="searchFilterChecked = !searchFilterChecked"
                />
                <div class="changeFilterPopupItemFields" style="flex-direction: column">
                  <Dropdown
                    placeholder="Search By"
                    :items="searchByItems"
                    itemKey="searchBy"
                    :selectedObject.sync="selectedSearchBy"
                    :isDisabled="!searchFilterChecked"
                    :isRequired="searchFilterChecked"
                    :errorMessage.sync="searchByErrorMessage"
                    textAlign="left"
                  />
                  <Dropdown
                    placeholder="Search Criteria"
                    :items="searchCriteriaItems"
                    itemKey="criteria"
                    :selectedObject.sync="selectedSearchCriteria"
                    :isDisabled="!searchFilterChecked"
                    :isRequired="searchFilterChecked"
                    :errorMessage.sync="searchCriteriaErrorMessage"
                    textAlign="left"
                  />
                  <Input
                    placeholder="Search"
                    :inputValue.sync="searchKeyword"
                    :isDisabled="!searchFilterChecked"
                    :isRequired="searchFilterChecked"
                    :errorMessage.sync="searchKeywordErrorMessage"
                  />
                </div>
              </div>
              <div class="changeFilterPopupRefreshButton">
                <button @click="refreshClicked">Refresh</button>
              </div>
            </div>
          </div>
          <div class="generalFilterContent"
            >Last Refreshed: {{ $dateTime.getDateTime(lastRefreshed, 'yyyy-MM-dd HH:mm') }}</div
          >
        </div>
      </div>

      <div class="rotTableBoxContainer">
        <TableBox
          :tableData="eROTListTableData"
          title="eROTs"
          :selectedRow.sync="selectedeROT"
          :loading="tableIsLoading"
          :downloadName="eROTTableBoxDownloadName"
          :maxSelection="-1"
          :additionalIconsIndex="[0]"
          :hideColumns="['eROT Status', 'freedemurrage', 'demurrageunit', 'freedetention', 'detentionunit', 'freestorage', 'storageunit']"
          :dataType="eROTListTableDataType"
        />
      </div>
    </div>

    <div v-if="showConfirmationPopup" class="confirmationPopupContainer">
      <div class="confirmationPopup">
        <table class="summaryHeader">
          <tr>
            <td>To</td>
            <td>:</td>
            <td>{{ selectedHaulier['Description'] }}</td>
          </tr>
          <tr>
            <td>eROT(s)</td>
            <td>:</td>
            <td>{{ selectedeROTList }}</td>
          </tr>
        </table>

        <div class="rotDetailsContainer">
          <div v-for="(eROT, index) of selectedeROT" :key="eROT['ROT #']" class="rotDetails">
            <div class="rotDetailsHeader">
              <table>
                <tr>
                  <td>ROT #</td>
                  <td>:</td>
                  <td>{{ eROT['ROT #'] }}</td>
                </tr>
                <tr>
                  <td>Shipper / Consignee</td>
                  <td>:</td>
                  <td>{{ eROT['Shipper/Consignee'] }}</td>
                </tr>
                <tr>
                  <td>Pickup</td>
                  <td>:</td>
                  <td>{{ eROT['Pick Up'] }}</td>
                </tr>
                <tr>
                  <td>Send To</td>
                  <td>:</td>
                  <td>{{ eROT['Send To'] }}</td>
                </tr>
                <tr>
                  <td>Dropoff</td>
                  <td>:</td>
                  <td>{{ eROT['Drop Off'] }}</td>
                </tr>
                <tr>
                  <td>No. of Containers</td>
                  <td>:</td>
                  <td>{{ eROT['Total Cont'] }}</td>
                </tr>
              </table>
              <table style="margin-left:10px;">
                <tr>
                  <td>Free Storage</td>
                  <td>:</td>
                  <td>{{ eROT['Free Storage'] }} {{eROT['storageunit'] == 'H' ? 'Hours' : 'Days'}}</td>
                </tr>
                <tr>
                  <td>Free Demurrage</td>
                  <td>:</td>
                  <td>{{ eROT['Free Demurrage'] }} {{eROT['demurrageunit'] == 'H' ? 'Hours' : 'Days'}}</td>
                </tr>
                <tr>
                  <td>Free Detention</td>
                  <td>:</td>
                  <td>{{ eROT['Free Detention'] }} {{eROT['detentionunit'] == 'H' ? 'Hours' : 'Days'}}</td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                </tr>
              </table>
              <div class="rotDetailsHeaderPrintContainer">
                <button class="rotDetailsHeaderPrintButton" @click="printROT(index)"
                  ><img src="https://img.icons8.com/android/96/000000/print.png" style="height: 20px; width: 20px" />
                  Print ROT</button
                >
              </div>
            </div>

            <div>
              <div class="rotAttachmentsContainer">
                <div class="rotAttachmentsTableBox">
                  <TableBox
                    :title="`${eROT['ROT #']} Attachments`"
                    :tableData="attachmentsTableData[index]"
                    :maxSelection="-1"
                    :selectedRow.sync="selectedAttachments[index]"
                    :hideColumns="['DocumentGUID']"
                    :dataType="{ 'Date Added': 'date' }"
                  />
                </div>
                <div class="rotAddAttachmentsContainer">
                  <div
                    ><Input
                      textType="file"
                      placeholder="Browse"
                      @fileChanged="fileChanged($event, index)"
                      :ref="`addAttachmentInput ${index}`"
                  /></div>
                  <div><Input placeholder="Remarks" :inputValue.sync="addAttachmentRemarks[index]" /></div>
                  <div><button @click="addAttachment(index)">Add Attachment</button></div>
                </div>
              </div>
              <div
                ><span v-if="selectedAttachmentsList(index)"
                  >Selected attachments: <strong>{{ selectedAttachmentsList(index) }}</strong></span
                ></div
              >
            </div>

            <hr v-if="index + 1 < selectedeROT.length" class="rotDetailsSeparator" />
            <!-- dont render if it is the last selectedeROT -->
          </div>
        </div>

        <div class="sendCancelButtonsContainer">
          <div class="sendCancelButton">
            <button @click="sendeROT()">Send</button>
          </div>
          <div class="sendCancelButton">
            <button @click="showConfirmationPopup = false">Cancel</button>
          </div>
        </div>

        <div v-if="showPager" class="printROTContainer" :style="{ opacity: showDesigner ? 1 : 0 }">
          <DesignerV2
            :viewMode="true"
            :reportFile="designerV2ReportFile"
            reportFolder="ROTForm"
            :reportData="pagerData"
            :show.sync="showPager"
            @pdfGenerated="pdfGenerated"
          />
          <!-- <Designer class="printROT" :quickPrint="true" :form="`ROT_${selectedHaulier['Haulier Code'].trim()}.json`" :data="pagerData" @cancel="showPager = false"/> -->
        </div>
      </div>
    </div>

    <PopupV2
      :show="showPopup"
      :type="popupType"
      :title="popupTitle"
      :content="popupContent"
      @buttonClicked="showPopup = false"
    />
    <Loader :isVisible="pageIsLoading" :loadingText="pageLoadingText" :isFullScreen="true" />
  </div>
</template>

<script>
import Menu from '@/components/Menus.vue';
// import Pager from '@/components/reportDesigner/Pager.vue';

export default {
  components: {
    Menu,
  },
  data: function () {
    return {
      menuItems: [{ title: 'Send eROT', icon: 'https://dsmlib.logistics.systems/Icons/SendBlack.png' }],

      // flags for status filter buttons at the top
      // styling for each of the buttons react to the state of their corresponding flag
      showPending: true,
      showSent: false,
      showAccepted: false,
      showRejected: false,

      // counter variables for status buttons at the top
      pendingeROTCount: 0,
      senteROTCount: 0,
      acceptedeROTCount: 0,
      rejectedeROTCount: 0,

      filtersSummary: '', // summary of filters used in last refresh (e.g. To ABC Haulier, from 2021-12-14 to 2021-12-31, CONTAINS ROT# 123), updated by UpdateFiltersSummary method
      lastRefreshed: new Date(),

      showChangeFilterPopup: false,
      haulierFilterItems: [],
      selectedHaulier: null,
      haulierFilterErrorMessage: '',

      dateFilterChecked: true,
      dateFilterStart: new Date(new Date().getFullYear(), new Date().getMonth(), 1), // first day of current month
      dateFilterStartErrorMessage: '',
      dateFilterEnd: new Date(), // current date
      dateFilterEndErrorMessage: '',

      searchFilterChecked: false,
      searchByItems: [
        { searchBy: 'ROT #', filterKey: 'ROT #' }, // searchBy is the value that is displayed in the dropdown
        { searchBy: 'Job #', filterKey: 'Job #' }, // filterKey is the key of the corresponding field in the data that you actually filter by
        { searchBy: 'Container #', filterKey: 'Container #' },
        { searchBy: 'Customer', filterKey: 'Customer' },
        { searchBy: 'Requested By', filterKey: 'Requested By' },
      ],
      selectedSearchBy: { searchBy: 'ROT #', filterKey: 'ROT #' }, // default to filter by ROT #
      searchByErrorMessage: '',
      searchCriteriaItems: [
        { criteria: 'CONTAINS' },
        { criteria: 'EQUALS' },
        { criteria: 'STARTS WITH' },
        { criteria: 'ENDS WITH' },
      ],
      selectedSearchCriteria: { criteria: 'CONTAINS' }, // default to CONTAINS
      searchCriteriaErrorMessage: '',
      searchKeyword: '',
      searchKeywordErrorMessage: '',

      eROTList: [], // contains all eROTs returned by the API, including all statuses, appended with status icons
      eROTListTableData: [], // bound to main TableBox, contains eROTs to be shown
      eROTListTableDataType: {
        'ROT Date': 'date',
        'Required Time': 'date',
        'Total Cont': 'number',
        'Cont Size': 'number',
        'Att Files': 'number',
      },
      selectedeROT: [], // bound to main TableBox, contains selected eROTs from the TableBox
      tableIsLoading: false,

      showConfirmationPopup: false, // popup that appears when user clicks on the 'Send eROT' button on the left
      rotDetails: [], // populated by getROTDetails upon clicking Send eROT on menu sidebar
      attachmentsTableData: [], // bound to TableBox
      selectedAttachments: [],

      addAttachmentFiles: [],
      addAttachmentRemarks: [],

      showPager: false, // show/hide Pager component for printing ROT forms
      pagerData: {}, // data sent to Pager component
      showDesigner: false,
      generatePDFResolve: null,

      showPopup: false, // show/hide PopupV2 component
      popupType: '',
      popupTitle: '',
      popupContent: '',

      pageIsLoading: false, // show/hide fullscreen loader
      pageLoadingText: 'Default Loading Text',
    };
  },
  computed: {
    selectedeROTList: function () {
      // generates a string containing selected eROT numbers separated by commas
      if (this.selectedeROT.length == 0)
        // e.g. BFI2103057-20, BFI2103057-21, BFI2103057-22
        return ''; // used to display selected eROTs in the confirmation popup

      let list = this.selectedeROT[0]['ROT #'];
      for (let i = 1; i < this.selectedeROT.length; i++) {
        list += `, ${this.selectedeROT[i]['ROT #']}`;
      }
      return list;
    },
    designerV2ReportFile: function () {
      if (!this.selectedHaulier) {
        return [];
      }
      return [`ROT_${this.selectedHaulier['Haulier Code'].trim()}.json`];
    },
    eROTTableBoxDownloadName: function () {
      let downloadName = 'eROTs';

      if (this.selectedHaulier?.['Haulier Code']) {
        downloadName += `_${this.selectedHaulier['Haulier Code']}`;
      }

      downloadName += `_${new Date().formatString('yyyy-MM-dd')}`;
      return downloadName;
    },
  },
  props: {},
  methods: {
    menuClicked: async function (menuItem) {
      switch (menuItem.title) {
        case 'Send eROT': {
          if (this.selectedeROT.length == 0) {
            this.popupType = 'error';
            this.popupTitle = 'No eROTs Selected';
            this.popupContent = 'Select at least one eROT to send';
            this.showPopup = true;
            break;
          }

          for (const selectedeROT of this.selectedeROT) {
            if (selectedeROT['eROT Status'] == 'Rejected') {
              this.popupType = 'error';
              this.popupTitle = 'Rejected eROT selected';
              this.popupContent = 'One or more selected eROTs have already been rejected by the haulier';
              this.showPopup = true;
              return;
            }
            if (selectedeROT['eROT Status'] == 'Accepted') {
              this.popupType = 'error';
              this.popupTitle = 'Accepted eROT selected';
              this.popupContent = 'One or more selected eROTs have already been accepted by the haulier';
              this.showPopup = true;
              return;
            }
          }

          await this.getROTDetails();
          this.showConfirmationPopup = true;

          //#region Getting all the attachments that have no ROTReport and generate them
          const indexToCreateReport = [];
          this.attachmentsTableData.forEach((ra, ind) => {
            const hasReport = ra.find((a) => a['File Name'].includes('ROT_'));
            if (!hasReport) {
              indexToCreateReport.push(ind);
            }
          });

          for (const icr of indexToCreateReport) {
            this.printROT(icr, true);
            await this.$nextTick();
            const prom = new Promise((r) => (this.generatePDFResolve = r));
            const reportBlob = await prom;
            reportBlob['name'] =
              `ROT_${this.selectedHaulier['Haulier Code']}_${this.selectedeROT[icr]['ROT #'].replace('/', '')}.pdf`;
            this.showPager = false;
            await this.$nextTick();
            this.addAttachmentFiles[icr] = this.addAttachmentFiles[icr] || [];
            this.addAttachmentFiles[icr].push(reportBlob);
            this.addAttachmentRemarks[icr] = 'Auto Generated report';
            this.addAttachment(icr);
          }
          //#endregion

          // Experimental code to programatically stretch attachments TableBox to fit the width of the containing div
          //
          //
          // this.$nextTick(() => {
          //   let container = document.getElementsByClassName('confirmationPopupContainer')[0];
          //   let tableBlockSize = container.getElementsByClassName('table-block')[0].getBoundingClientRect();
          //   let header = Array.from(container.getElementsByClassName('table-header'));

          //   let tableSize = tableBlockSize.width;
          //   console.log(tableSize);

          //   console.log(header[0].children[0]);
          //   console.log(header[0].children[2]);
          //   console.log(header[0].children[0].getBoundingClientRect().width());
          //   console.log(header[0].children[2].getBoundingClientRect().width);
          //   let otherSize = header[0].children[0].getBoundingClientRect().width + header[0].children[2].getBoundingClientRect().width;
          //   console.log(otherSize);
          //   console.log(tableSize - otherSize);

          //   // header.forEach(h => {
          //   //   console.log(h.children[1]);
          //   // });
          // });
          break;
        }
      }
    },
    toggleStatus: function (status) {
      // called when any of the status filter buttons are clicked
      switch (
        status // a string indicating which button was pressed is passed to the method
      ) {
        case 'pending':
          this.showPending = !this.showPending; // toggle the corresponding flag
          break;

        case 'sent':
          this.showSent = !this.showSent;
          break;

        case 'accepted':
          this.showAccepted = !this.showAccepted;
          break;

        case 'rejected':
          this.showRejected = !this.showRejected;
          break;
      }

      this.eROTListTableData = []; // clear TableBox data
      this.$nextTick(() => {
        this.eROTListTableData = this.filterStatus(); // call filter status to filter out eROTs hidden by the user, assign returned value to TableBox data
      });
    },
    filterStatus: function () {
      let filtered = this.eROTList; // copy over full list of eROTs

      if (!this.showPending)
        filtered = filtered.filter((eROT) => {
          return eROT['eROT Status'] != 'Pending';
        }); // filter out Pending eROTs

      if (!this.showSent)
        filtered = filtered.filter((eROT) => {
          return eROT['eROT Status'] != 'Sent';
        }); // filter out Sent eROTs

      if (!this.showAccepted)
        filtered = filtered.filter((eROT) => {
          return eROT['eROT Status'] != 'Accepted';
        }); // filter out Accepted eROTs

      if (!this.showRejected)
        filtered = filtered.filter((eROT) => {
          return eROT['eROT Status'] != 'Rejected';
        }); // filter out Rejected eROTs

      return filtered; // return the filtered list
    },
    updateFiltersSummary: function () {
      // update filter summary string above the change filter button
      let summary = `To ${this.selectedHaulier['Description']}`; // e.g. To ABC Haulier, from 2021-12-13 to 2021-12-14, ROT# CONTAINS 123

      if (this.searchFilterChecked)
        summary += `, ${this.selectedSearchBy['searchBy']} ${this.selectedSearchCriteria['criteria']} ${this.searchKeyword}`;

      if (this.dateFilterChecked)
        summary += `, from ${this.$dateTime.getDateTime(this.dateFilterStart, 'yyyy-MM-dd')} to ${this.$dateTime.getDateTime(this.dateFilterEnd, 'yyyy-MM-dd')}`;

      this.filtersSummary = summary;
    },
    refreshClicked: async function () {
      // check if there are any incomplete fields
      let incompleteFields = false;

      if (!this.selectedHaulier) {
        // if selectedHaulier is null
        this.haulierFilterErrorMessage = 'Select a haulier';
        incompleteFields = true;
      }

      if (this.dateFilterChecked) {
        if (!this.dateFilterStart) {
          // if starting date is null
          this.dateFilterStartErrorMessage = 'Enter a date';
          incompleteFields = true;
        }
        if (!this.dateFilterEnd) {
          // if ending date is null
          this.dateFilterEndErrorMessage = 'Enter a date';
          incompleteFields = true;
        }
      }

      if (this.searchFilterChecked) {
        if (!this.selectedSearchBy) {
          // if selectedSearchBy is null
          this.searchByErrorMessage = 'Choose a field to search by';
          incompleteFields = true;
        }
        if (!this.selectedSearchCriteria) {
          // if selectedSearchCriteria is null
          this.searchCriteriaErrorMessage = 'Choose a search criteria';
          incompleteFields = true;
        }
        if (!this.searchKeyword) {
          // if searchKeyword is null
          this.searchKeywordErrorMessage = 'Enter a keyword to search for';
          incompleteFields = true;
        }
      }

      if (incompleteFields)
        // if any of the above fields were empty, exit function
        return;

      // else, close the popup and begin getting eROTs from API
      this.showChangeFilterPopup = false;
      this.pageLoadingText = 'Getting eROTs';
      this.pageIsLoading = true;
      this.tableIsLoading = true;

      try {
        let apiURL = `/ROT/GeteROT?hauliercode=${this.selectedHaulier['Haulier Code']}`;

        if (this.dateFilterChecked) {
          apiURL += `&strotdate=${this.$dateTime.getDateTime(this.dateFilterStart, 'yyyy-MM-dd')}`;
          apiURL += `&edrotdate=${this.$dateTime.getDateTime(this.dateFilterEnd, 'yyyy-MM-dd')}`;
        }

        this.eROTList = await this.$apiCallV2(apiURL);

        if (this.searchFilterChecked) {
          // search by certain criteria
          switch (this.selectedSearchCriteria['criteria']) {
            case 'CONTAINS':
              this.eROTList = this.eROTList.filter((eROT) => {
                return eROT[this.selectedSearchBy['filterKey']].includes(this.searchKeyword);
              });
              break;

            case 'EQUALS':
              this.eROTList = this.eROTList.filter((eROT) => {
                return eROT[this.selectedSearchBy['filterKey']] == this.searchKeyword;
              });
              break;

            case 'STARTS WITH':
              this.eROTList = this.eROTList.filter((eROT) => {
                return eROT[this.selectedSearchBy['filterKey']].startsWith(this.searchKeyword);
              });
              break;

            case 'ENDS WITH':
              this.eROTList = this.eROTList.filter((eROT) => {
                return eROT[this.selectedSearchBy['filterKey']].endsWith(this.searchKeyword);
              });
              break;
          }
        }

        this.eROTList = this.eROTList.map((eROT) => {
          // append status icons
          switch (eROT['eROT Status']) {
            case 'Pending':
              return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/ClockBlack.png' }, eROT);

            case 'Sent':
              return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/SendBlack.png' }, eROT);

            case 'Accepted':
              return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusComplete.png' }, eROT);

            case 'Rejected':
              return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/StatusCancelled.png' }, eROT);
          }
        });

        this.selectedeROT = []; // clear selectedeROT array
        this.eROTListTableData = []; // clear TableBox data
        this.$nextTick(() => {
          this.eROTListTableData = this.filterStatus(); // filter out eROTs with statuses hidden by the user
        });

        this.updateFiltersSummary();
        this.updateStatusCounters();
        this.lastRefreshed = new Date();
      } catch (e) {
        //console.log(e);
      }

      this.pageIsLoading = false;
      this.tableIsLoading = false;
    },
    updateStatusCounters: function () {
      let eROTList = this.eROTList; // copy over full list of eROTs
      let totaleROTs = eROTList.length; // get total eROTs (all statuses)

      eROTList = eROTList.filter((eROT) => {
        return eROT['eROT Status'] != 'Pending';
      }); // filter out pending eROTs and update eROTList
      this.pendingeROTCount = totaleROTs - eROTList.length; // no. of pending eROTs = all statuses - remaining eROTs after filtering out pending
      totaleROTs = eROTList.length; // update totaleROTS (all statuses except pending)

      eROTList = eROTList.filter((eROT) => {
        return eROT['eROT Status'] != 'Sent';
      }); // filter out sent eROTs
      this.senteROTCount = totaleROTs - eROTList.length; // no. of sent eROTs = (sent + accepted + rejected) - remaining after filtering out sent
      totaleROTs = eROTList.length; // update totaleROTs (only accepted + rejected left)

      eROTList = eROTList.filter((eROT) => {
        return eROT['eROT Status'] != 'Accepted';
      });
      this.acceptedeROTCount = totaleROTs - eROTList.length;
      totaleROTs = eROTList.length;

      eROTList = eROTList.filter((eROT) => {
        return eROT['eROT Status'] != 'Rejected';
      });
      this.rejectedeROTCount = totaleROTs - eROTList.length;
    },
    getROTDetails: async function () {
      // get full ROT details for each selected eROT
      this.pageLoadingText = 'Getting ROT Details';
      this.pageIsLoading = true;

      // generate strings containing all ROT and Job numbers separated with commas
      const rotNo = this.selectedeROT.map((s) => s['ROT #']).join(',');
      const jobNo = this.selectedeROT.map((s) => s['Job #']).join(',');
      // the reason selectedeROTList wasn't used for rotNo is because selectedeROTList inserts a space in between each ROT
      // the API doesn't work if there's a space

      this.rotDetails = []; // clear rotDetails
      let rotDetails = await this.$apiCallV2(`/ROT/GetROTDetails?cmrno=${rotNo}&jobno=${jobNo}`);

      if (this.selectedeROT.length == 1) {
        // if only one ROT is selected
        this.rotDetails.push(rotDetails['ROTDetails']['CMRForm']); // the API will return a JSON object containing details for that ROT
      } else {
        // if more than one is selected
        rotDetails = rotDetails['ROTDetails']['CMRForm']; // the API will sort the rotDetails according to ROT # before returning an array

        for (const selected of this.selectedeROT) {
          // code to rearrange the retrieved rot details according to the order in selectedeROT
          const index = rotDetails.findIndex((rot) => {
            return rot['CMR No'] == selected['ROT #'];
          }); // find the index of the corresponding rot details
          this.rotDetails.push(rotDetails.splice(index, 1)[0]); // splice out the found rot details and push it to this.rotDetails
          this.rotDetails.forEach((r) => {
            r['ContDetail'].forEach((c, ci) => (c['#'] = ci + 1));
          });
        }
      }

      this.addAttachmentFiles = [];
      this.addAttachmentRemarks = [];
      for (let i = 0; i < this.selectedeROT.length; i++) {
        // for every selectedeROT, push a default value to addAttachmentFiles and addAttachmentRemarks
        this.$set(this.addAttachmentFiles, i, null); // using $set because the components wont react to data changes if push is used
        this.$set(this.addAttachmentRemarks, i, ''); // using $set because the components wont react to data changes if push is used
      }

      const rotAttachments = []; // contains attachments for each selected eROT
      const selectedROTAttachments = []; // contains the selected attachments for each selected eROT
      for (let i = 0; i < this.rotDetails.length; i++) {
        const rot = this.rotDetails[i];
        if (!rot['Doc'])
          // if there is no Doc field
          rot['Doc'] = []; // create the Doc field and assign an empty array

        rotAttachments.push(
          rot['Doc'].map((doc) => {
            // change the field names of attachments from rotDetails
            return {
              // and push each attachment into rotAttachments
              'File Name': doc['File Name'],
              'Date Added': this.$dateTime.getDateTime(doc['Doc Date'], 'yyyy-MM-dd'),
              Remarks: doc['Doc Remark'],
              DocumentGUID: doc['Document GUID'],
            };
          }),
        );

        if (this.selectedeROT[i]['eROT Status'] == 'Pending')
          // if the selected eROT hasn't been sent before
          selectedROTAttachments.push([...rotAttachments[i]]); // default to all attachments being selected
        else {
          // else, reselect the attachments that were selected last time this eROT was sent
          try {
            const mostRecenteROTJSONBody = await this.getMostRecenteROTJSONBody(rot['Job No'], rot['CMR No']);

            selectedROTAttachments.push([]); // start with a blank array
            for (const attachment of JSON.parse(atob(mostRecenteROTJSONBody['JSONBody']))['attachments']) {
              // iterate through attachments in the latest json file
              const found = rotAttachments[i].find((rotAttachment) => {
                return rotAttachment['DocumentGUID'] == attachment['doc_GUID'];
              }); // try looking for the corresponding attachment in rotAttachment by GUID
              if (found) selectedROTAttachments[i].push(found); // if found, push it to selectedROTAttachments
            }
          } catch (e) {
            //console.log(e);
          }
        }
      }

      this.selectedAttachments = [];
      this.attachmentsTableData = []; // clear TableBox data
      this.$nextTick(() => {
        for (let i = 0; i < rotAttachments.length; i++) {
          this.$set(this.attachmentsTableData, i, [...rotAttachments[i]]); // using $set because the component wont react to data changes if i use push
          this.$set(this.selectedAttachments, i, [...selectedROTAttachments[i]]); // using $set because the component wont react to data changes if i use push
        }
        this.pageIsLoading = false;
      });
    },
    getMostRecenteROTJSONBody: async function (jobNo, rotNo) {
      // get the request body POSTed to SaveHAUBooking last time this eROT was sent
      // the request body is stored as a json file and attached to the Job
      // first, get all job documents attached to that job
      const mostRecenteROTJSONBody = await this.$apiCallV2(`/FreightForwarding/GetJobDocuments?jobno=${jobNo}`);

      // the json file will have 'eROT' as its doc code of and the ROT # as the reference no
      return mostRecenteROTJSONBody
        .filter((doc) => {
          return doc['Doc Code'] == 'eROT' && doc['Reference No'] == rotNo; // filter out files that do not fit this criteria
        })
        .map((doc) => {
          // the json file is named as: 'eROT_${ROT #}_${DateTime Sent}_${counter}.json', counter increases by 1 everytime that eROT is sent
          let JSONCounter = doc['AttImageName'].split('_'); // get the counter value from the file name
          JSONCounter = JSONCounter[JSONCounter.length - 1].split('.')[0].trim();

          return {
            // map each json file to a json object containing the contents of the file and the counter value
            JSONBody: doc['AttImage'],
            JSONCounter: parseInt(JSONCounter),
          };
        })
        .sort((first, second) => {
          // sort the json files according to the counter in descending order (the one with the highest counter is the most recent one)
          return first['JSONCounter'] > second['JSONCounter'] ? -1 : 1;
        })[0]; // get the most recent json file (index 0)
    },
    printROT: function (index, hide) {
      // called when a print ROT button is clicked, index of ROT button pressed is passed in (needed because users may select more than one eROT)
      this.showDesigner = !hide;

      this.pagerData = JSON.parse(JSON.stringify(this.rotDetails[index])); // clone object

      //const preferredDateFormat = this.$store.state['preferredDateFormat']; // get user's preferred date format from vuex state
      //   const formatDateTime = (dateTime, format) => {
      //     // wrapper for this.$dateTime.getDateTime, only used for printROT
      //     if (!dateTime)
      //       // if dateTime is null, dont return anything
      //       return; // returning null here would create another field in the data with a null value

      //     return this.$dateTime.getDateTime(dateTime, format);
      //   };

      //#region Format all the dates
      this.pagerData['formatETAPrintDateTime'] =
        this.pagerData['ETA'] ? new Date(this.pagerData['ETA']).formatString('yyyy-MM-dd HH:mm') : '';
      this.pagerData['formatETAPrintDate'] =
        this.pagerData['ETA'] ? new Date(this.pagerData['ETA']).formatString('yyyy-MM-dd') : '';
      this.pagerData['formatCMRTime'] =
        this.pagerData['CMR Time'] ? new Date(this.pagerData['CMR Time']).formatString('yyyy-MM-dd HH:mm') : '';
      this.pagerData['formatPrintedOn'] = new Date().formatString('yyyy-MM-dd HH:mm');
      this.pagerData['formatTimeRequiredFrom'] =
        this.pagerData['Time Required From'] ?
          new Date(this.pagerData['Time Required From']).formatString('yyyy-MM-dd')
        : '';
      this.pagerData['formatDateTimeRequiredFrom'] =
        this.pagerData['Time Required From'] ?
          new Date(this.pagerData['Time Required From']).formatString('yyyy-MM-dd HH:mm')
        : '';
      //#endregion

      //#region Format the container summary to remove all the Type
      const containerSummary = this.pagerData['Cont Summary'];
      this.pagerData['formatContainerSize'] = containerSummary;
      //#endregion

      this.pagerData['Weight'] = parseFloat(this.pagerData['Weight']).toFixed(2);
      this.pagerData['Weight (Tonne)'] = parseFloat(this.pagerData['Weight (Tonne)']).toFixed(2);
      this.pagerData['M3'] = parseFloat(this.pagerData['M3']).toFixed(2);

      this.pagerData['Seal No'] = this.pagerData['ContDetail'][0]['Seal No'];

      this.pagerData['Bill To Contact'] =
        this.pagerData['Bill To Contact'] == 'Tel: / Fax:' ? '' : this.pagerData['Bill To Contact'];

      if (this.pagerData['ContDetail']) {
        this.pagerData['ContDetail'].forEach((c) => {
          if (c['Seal Required Date'].includes('\r')) {
            const split = c['Seal Required Date'].split('\r');
            c['Seal Required Date'] = new Date(split[1]).formatString('yyyy-MM-dd');
          }
        });
      }

      //#region FOR IW ROT Forms
      this.pagerData['isOffLoad'] = this.pagerData['Offload At Premis'] == '1' ? 'X' : '';

      this.pagerData['isExp'] = this.pagerData['Job Type'] == 'EXPORT' ? 'X' : '';
      this.pagerData['isOneWayExp'] =
        this.pagerData['Job Type'] == 'EXPORT' && this.pagerData['Trip Desc'] == '1-WAY' ? 'X' : '';
      this.pagerData['isSLExp'] =
        this.pagerData['Job Type'] == 'EXPORT' && this.pagerData['Sideloader Label'] ? 'X' : '';

      this.pagerData['isImp'] = this.pagerData['Job Type'] == 'IMPORT' ? 'X' : '';
      this.pagerData['isOneWayImp'] =
        this.pagerData['Job Type'] == 'IMPORT' && this.pagerData['Trip Desc'] == '1-WAY' ? 'X' : '';
      this.pagerData['isSLImp'] =
        this.pagerData['Job Type'] == 'IMPORT' && this.pagerData['Sideloader Label'] ? 'X' : '';
      //#endregion

      //#region FOR MH ROT Forms
      this.pagerData['isOfficeHrs'] = this.pagerData['Office Hours Label'].includes('ffice') ? 'X' : '';
      this.pagerData['isTwentyFourHrs'] = !this.pagerData['Office Hours Label'].includes('ffice') ? 'X' : '';
      this.pagerData['isTR'] = this.pagerData['Delivery Type'] == 'TR' ? 'X' : '';
      this.pagerData['isSL'] = this.pagerData['Delivery Type'] != 'TR' ? 'X' : '';
      //#endregion

      //#region Format Send To Address
      const sendToAddress = [
        this.pagerData['Send To Add1'],
        this.pagerData['Send To Add2'],
        this.pagerData['Send To Add3'],
        this.pagerData['Send To Add4'],
        `${this.pagerData['Send To PostCode']} ${this.pagerData['Send To City']}, ${this.pagerData['Send To State']}`,
        this.pagerData['Send To Country'],
      ];
      this.pagerData['formatSendToAddress'] = sendToAddress.filter((s) => s).join('\n');
      //#endregion

      if (this.pagerData['ContDetail']) {
        if (this.pagerData['ContDetail'].length > 10) {
          this.pagerData['ContDetailLong'] = this.pagerData['ContDetail'];
        }
      }

      if (this.pagerData['ContDetailLong']) {
        delete this.pagerData['ContDetail'];
        this.pagerData['ContMessage'] = 'Please refer to container attachment.';
        this.pagerData['ContDetailLong'].forEach((c) => {
          c['SizeType'] = `${c['Size']}${c['Cont Type']}`;
          const time = c['Required Time'].split('');
          time.splice(2, 0, ':');
          c['Required DateTime'] = `${new Date(c['Required DateTime']).formatString('yyyy-MM-dd')} ${time.join('')}`;
        });
      } else {
        this.pagerData['ContDetail'].forEach((c) => {
          const time = c['Required Time'].split('');
          time.splice(2, 0, ':');
          c['Required Time'] = time.join('');
          c['Required DateTime'] = new Date(c['Required DateTime']).formatString('yyyy-MM-dd');
        });
      }

      this.showPager = true;
    },
    selectedAttachmentsList: function (index) {
      // generates a string containing selected attachment filenames separated by commas
      if (this.selectedAttachments[index].length == 0)
        // e.g. test.txt, test2.txt, test3.txt
        return ''; // generated string is displayed in confirmation popup

      let list = this.selectedAttachments[index][0]['File Name'];
      for (let i = 1; i < this.selectedAttachments[index].length; i++) {
        list += `, ${this.selectedAttachments[index][i]['File Name']}`;
      }

      return list;
    },
    fileChanged: function (file, index) {
      this.addAttachmentFiles[index] = file;
    },
    addAttachment: async function (index) {
      if (!this.addAttachmentFiles[index] || this.addAttachmentFiles[index].length == 0) {
        // if no file has been selected by the user
        this.popupType = 'error';
        this.popupTitle = 'No File Selected';
        this.popupContent = 'Browse for a file to add as an attachment';
        this.showPopup = true;
        return;
      }

      // else, start uploading the file
      this.pageLoadingText = 'Uploading attachment';
      this.pageIsLoading = true;

      const jobNo = this.selectedeROT[index]['Job #'];
      const document = [
        {
          'Doc Code': 'ECMR',
          'Doc Ref #': this.selectedeROT[index]['ROT #'],
          Attachment: this.addAttachmentFiles[index][0]['name'],
          Remarks: this.addAttachmentRemarks[index],
          Status: '',
          'Start Date': '',
          'Received Date': '',
          system: 'eSendCMR',
          'Due Date': '',
          'Assign To': '',
          Sets: '',
          Page: '',
          documentguid: '',
          statusseqno: '',
          fileAtt: await this.$convertFile.toBase64(this.addAttachmentFiles[index][0]),
          filetype: this.addAttachmentFiles[index][0]['type'],
          Action: 'N',
        },
      ];

      // Check if file type and name is present
      if (!document[0]['Attachment'] || document[0]['Attachment'] == '' || !document[0]['filetype']) {
        this.popupType = 'error';
        this.popupTitle = 'Add attachment failed';
        this.popupContent = 'Your file is not suitable to upload!';
        this.showPopup = true;
        this.pageIsLoading = false;
        return;
      }

      // Check if file has no data
      if (document[0]['Attachment'] == '' || !document[0]['fileAtt'] || !document[0]['filetype']) {
        this.popupType = 'error';
        this.popupTitle = 'Add attachment failed';
        this.popupContent = 'Your file is empty!';
        this.showPopup = true;
        this.pageIsLoading = false;
        return;
      }

      const saveJobDocument = await this.$apiCallV2(`/ROT/SaveJobDocument?jobno=${jobNo}`, { documents: document });

      if (saveJobDocument[0]['Results'] != 0) {
        // if failed to upload attachment
        this.popupType = 'error';
        this.popupTitle = 'Add attachment failed';
        this.popupContent = saveJobDocument[0]['ErrMsg'];
        this.showPopup = true;
        this.pageIsLoading = false;
        return;
      }

      // get the added attachment back using GetROTDetails
      const rotDetails = await this.$apiCallV2(
        `/ROT/GetROTDetails?cmrno=${this.selectedeROT[index]['ROT #']}&jobno=${this.selectedeROT[index]['Job #']}`,
      );
      this.rotDetails[index] = rotDetails['ROTDetails']['CMRForm'];

      this.$refs[`addAttachmentInput ${index}`][0].clearAttachmentClicked(); // clear file input
      this.addAttachmentRemarks[index] = ''; // clear attachments input

      const attachments = this.rotDetails[index]['Doc'].map((doc) => {
        return {
          'File Name': doc['File Name'],
          'Date Added': this.$dateTime.getDateTime(doc['Doc Date'], 'yyyy-MM-dd'),
          Remarks: doc['Doc Remark'],
          DocumentGUID: doc['Document GUID'],
        };
      });

      const selectedAttachments = this.selectedAttachments[index].map((attachment) => {
        return attachment['DocumentGUID'];
      });
      this.$set(this.selectedAttachments, index, []); // using $set because the component wont react to data changes if i use assignment
      this.$set(this.attachmentsTableData, index, []); // using $set because the component wont react to data changes if i use assignment

      this.$nextTick(() => {
        this.$set(this.attachmentsTableData, index, [...attachments]); // using $set because the component wont react to data changes if i use assignment
        this.$set(
          this.selectedAttachments,
          index,
          attachments.filter((attachment) => {
            return selectedAttachments.includes(attachment['DocumentGUID']);
          }),
        ); // using $set because the component wont react to data changes if i use assignment
        this.pageIsLoading = false;
      });
    },
    sendeROT: async function () {
      // send eROT to the haulier
      const currentDateTime = new Date(); // current date and current time is needed a few times
      // to ensure consistency across all API calls, reuse the same Date object
      this.pageIsLoading = true;
      for (let rotIndex = 0; rotIndex < this.rotDetails.length; rotIndex++) {
        // generate request body
        this.pageLoadingText = `Sending ROT ${this.rotDetails[rotIndex]['CMR No']}`;

        const loginDetails = await this.$apiCallV2('/Login/GetDetails');

        const rotDetails = this.rotDetails[rotIndex];
        const saveHAUBookingRequestBody = {
          action: '', // either 'N' or 'E', depending on eROT status, code that fills in this field below
          cu_number: rotDetails['Cu Number'] ? rotDetails['Cu Number'] : '',
          cmr_no: rotDetails['CMR No'] ? rotDetails['CMR No'] : '',
          job_no: rotDetails['Job No'] ? rotDetails['Job No'] : '',
          job_date: rotDetails['Job Date'] ? this.$dateTime.getDateTime(rotDetails['Job Date'], 'yyyy-MM-dd') : '',
          job_type: rotDetails['Job_Type'] ? rotDetails['Job_Type'].trim() : '',
          vessel_no: rotDetails['Vessel ID'] ? rotDetails['Vessel ID'] : '',
          vessel_name: rotDetails['Vessel Name'] ? rotDetails['Vessel Name'] : '',
          voyno: rotDetails['Voy No'] ? rotDetails['Voy No'] : '',
          shipcall_no: rotDetails['Ship Call No'] ? rotDetails['Ship Call No'] : '',
          shipline: rotDetails['Shipping Line'] ? rotDetails['Shipping Line'] : '',
          urgent: rotDetails['Urgency'] ? rotDetails['Urgency'] : '',
          imp_port:
            rotDetails['Job_Type'] ?
              rotDetails['Job_Type'].trim() == 'I' ?
                rotDetails['Port of Discharge']
              : ''
            : '',
          imp_portname:
            rotDetails['Job_Type'] ?
              rotDetails['Job_Type'].trim() == 'I' ?
                rotDetails['POD Name']
              : ''
            : '',
          load_port: rotDetails['Port of Loading'] ? rotDetails['Port of Loading'] : '',
          load_portname: rotDetails['POL Name'] ? rotDetails['POL Name'] : '',
          trans: rotDetails['Transhipment Port'] || rotDetails['POT Name'] ? '1' : '0',
          trans_port: rotDetails['Transhipment Port'] ? rotDetails['Transhipment Port'] : '',
          trans_portname: rotDetails['POT Name'] ? rotDetails['POT Name'] : '',
          operator_code: rotDetails['Port Operator'] ? rotDetails['Port Operator'] : '',
          operator_name: rotDetails['Port Operator Name'] ? rotDetails['Port Operator Name'] : '',
          currency: rotDetails['Currency'] ? rotDetails['Currency'] : '',
          spc_treatment: rotDetails['Special Treatment'] ? rotDetails['Special Treatment'] : '',
          ag_code: rotDetails['Shipping Agt'] ? rotDetails['Shipping Agt'] : '',
          ag_name: rotDetails['Shipping Agt Name'] ? rotDetails['Shipping Agt Name'] : '',
          ag_sname: rotDetails['Shipping Agt Short Name'] ? rotDetails['Shipping Agt Short Name'] : '',
          frtship_name: rotDetails['Frt Forwarder Name'] ? rotDetails['Frt Forwarder Name'] : '',
          discharge_port: rotDetails['Port of Discharge'] ? rotDetails['Port of Discharge'] : '',
          discharge_portname: rotDetails['POD Name'] ? rotDetails['POD Name'] : '',
          date_eta: rotDetails['ETA'] ? this.$dateTime.getDateTime(rotDetails['ETA'], 'yyyy-MM-dd') : '',
          date_etd: rotDetails['ETD'] ? this.$dateTime.getDateTime(rotDetails['ETD'], 'yyyy-MM-dd') : '',
          datedemurage: '',
          datedetention: '',
          bookingrefno: rotDetails['Booking Ref No'] ? rotDetails['Booking Ref No'] : '',
          finaldest: rotDetails['Final Dest'] ? rotDetails['Final Dest'] : '',
          pickup: rotDetails['Pick Up'] ? rotDetails['Pick Up'] : '',
          dropoff: rotDetails['Drop Off'] ? rotDetails['Drop Off'] : '',
          trip: rotDetails['Trip'] ? rotDetails['Trip'] : '',
          destination_code: rotDetails['Destination Code'] ? rotDetails['Destination Code'] : '',
          company: rotDetails['Send To Company'] ? rotDetails['Send To Company'] : '',
          addr1: rotDetails['Send To Add1'] ? rotDetails['Send To Add1'] : '',
          addr2: rotDetails['Send To Add2'] ? rotDetails['Send To Add2'] : '',
          addr3: rotDetails['Send To Add3'] ? rotDetails['Send To Add3'] : '',
          addr4: rotDetails['Send To Add4'] ? rotDetails['Send To Add4'] : '',
          phone: rotDetails['Send To Tel'] ? rotDetails['Send To Tel'] : '',
          attn: rotDetails['Send To Attn'] ? rotDetails['Send To Attn'] : '',
          fax: rotDetails['Send To Fax'] ? rotDetails['Send To Fax'] : '',
          totalcont: rotDetails['Total Container'] ? rotDetails['Total Container'] : '',
          requestno: rotDetails['Request No'] ? rotDetails['Request No'] : '',
          daterequest: rotDetails['CMR Time'] ? this.$dateTime.getDateTime(rotDetails['CMR Time'], 'yyyy-MM-dd') : '',
          requestedby: rotDetails['Requested By'] ? rotDetails['Requested By'] : '',
          curefno: rotDetails['Cust Ref No'] ? rotDetails['Cust Ref No'] : '',
          closingtime:
            rotDetails['Closing Time'] ? this.$dateTime.getDateTime(rotDetails['Closing Time'], 'yyyy-MM-dd') : '',
          description: '',
          indicator: 'N',
          datereceived: this.$dateTime.getDateTime(currentDateTime, 'yyyy-MM-dd'), // current date
          timereceived: this.$dateTime.getDateTime(currentDateTime, 'HHmm'), // current time
          dateupdate: this.$dateTime.getDateTime(currentDateTime, 'yyyy-MM-dd'), // current date
          timeupdate: this.$dateTime.getDateTime(currentDateTime, 'HHmm'), // current time
          orderno: rotDetails['Cust Ref No'] ? rotDetails['Cust Ref No'] : '',
          cu_name: rotDetails['Cu Name'] ? rotDetails['Cu Name'] : '',
          senderco: loginDetails['CoRefname'],
          cu_addr1: rotDetails['Cust Add1'] ? rotDetails['Cust Add1'] : '',
          cu_addr2: rotDetails['Cust Add2'] ? rotDetails['Cust Add2'] : '',
          cu_addr3: rotDetails['Cust Add3'] ? rotDetails['Cust Add3'] : '',
          cu_addr4: rotDetails['Cust Add4'] ? rotDetails['Cust Add4'] : '',
          postcode: rotDetails['Cust PostCode'] ? rotDetails['Cust PostCode'] : '',
          city: rotDetails['Cust City'] ? rotDetails['Cust City'] : '',
          state: rotDetails['Cust State'] ? rotDetails['Cust State'] : '',
          country: rotDetails['Cust Country'] ? rotDetails['Cust Country'] : '',
          cu_phone: rotDetails['Cust Tel'] ? rotDetails['Cust Tel'] : '',
          cu_fax: rotDetails['Cust Fax'] ? rotDetails['Cust Fax'] : '',
          pickup_company: rotDetails['Pick Up Company'] ? rotDetails['Pick Up Company'] : '',
          pickup_addr1: rotDetails['Pick Up Add1'] ? rotDetails['Pick Up Add1'] : '',
          pickup_addr2: rotDetails['Pick Up Add2'] ? rotDetails['Pick Up Add2'] : '',
          pickup_addr3: rotDetails['Pick Up Add3'] ? rotDetails['Pick Up Add3'] : '',
          pickup_addr4: rotDetails['Pick Up Add4'] ? rotDetails['Pick Up Add4'] : '',
          pickup_city: rotDetails['Pick Up City'] ? rotDetails['Pick Up City'] : '',
          pickup_state: rotDetails['Pick Up State'] ? rotDetails['Pick Up State'] : '',
          pickup_country: rotDetails['Pick Up Country'] ? rotDetails['Pick Up Country'] : '',
          pickup_phone: rotDetails['Pick Up Tel'] ? rotDetails['Pick Up Tel'] : '',
          pickup_fax: rotDetails['Pick Up Fax'] ? rotDetails['Pick Up Fax'] : '',
          pickup_postcode: rotDetails['Pick Up PostCode'] ? rotDetails['Pick Up PostCode'] : '',
          sendto_company: rotDetails['Send To Company'] ? rotDetails['Send To Company'] : '',
          sendto_addr1: rotDetails['Send To Add1'] ? rotDetails['Send To Add1'] : '',
          sendto_addr2: rotDetails['Send To Add2'] ? rotDetails['Send To Add2'] : '',
          sendto_addr3: rotDetails['Send To Add3'] ? rotDetails['Send To Add3'] : '',
          sendto_addr4: rotDetails['Send To Add4'] ? rotDetails['Send To Add4'] : '',
          sendto_city: rotDetails['Send To City'] ? rotDetails['Send To City'] : '',
          sendto_state: rotDetails['Send To State'] ? rotDetails['Send To State'] : '',
          sendto_country: rotDetails['Send To Country'] ? rotDetails['Send To Country'] : '',
          sendto_phone: rotDetails['Send To Tel'] ? rotDetails['Send To Tel'] : '',
          sendto_fax: rotDetails['Send To Fax'] ? rotDetails['Send To Fax'] : '',
          sendto_postcode: rotDetails['Send To PostCode'] ? rotDetails['Send To PostCode'] : '',
          sendto_attn: rotDetails['Send To Attn'] ? rotDetails['Send To Attn'] : '',
          dropoff_company: rotDetails['Drop Off Company'] ? rotDetails['Drop Off Company'] : '',
          dropoff_addr1: rotDetails['Drop Off Add1'] ? rotDetails['Drop Off Add1'] : '',
          dropoff_addr2: rotDetails['Drop Off Add2'] ? rotDetails['Drop Off Add2'] : '',
          dropoff_addr3: rotDetails['Drop Off Add3'] ? rotDetails['Drop Off Add3'] : '',
          dropoff_addr4: rotDetails['Drop Off Add4'] ? rotDetails['Drop Off Add4'] : '',
          dropoff_city: rotDetails['Drop Off City'] ? rotDetails['Drop Off City'] : '',
          dropoff_state: rotDetails['Drop Off State'] ? rotDetails['Drop Off State'] : '',
          dropoff_country: rotDetails['Drop Off Country'] ? rotDetails['Drop Off Country'] : '',
          dropoff_phone: rotDetails['Drop Off Tel'] ? rotDetails['Drop Off Tel'] : '',
          dropoff_fax: rotDetails['Drop Off Fax'] ? rotDetails['Drop Off Fax'] : '',
          dropoff_postcode: rotDetails['Drop Off PostCode'] ? rotDetails['Drop Off PostCode'] : '',
          frtship_no: rotDetails['Frt Forwarder'] ? rotDetails['Frt Forwarder'] : '',
          autorequestno: '', // either blank or containing a unique number, depending on eROT status, code that fills in this field below
          cnjobtype: '',
          sendto_chamareacode: rotDetails['Send To Area'] ? rotDetails['Send To Area'] : '',
          bookingsource: 'W',
          billto: rotDetails['eROT Bill To'] ? rotDetails['eROT Bill To'].trim() : '',
          getautorequestno: '1',

          freestorageval: rotDetails['FreeStorage'], 
          freedemurrage: rotDetails['FreeDemurrage'],
          freedetention: rotDetails['FreeDetention'],
          storageunit: rotDetails['StorageUnit'],
          demurrageunit: rotDetails['DemurrageUnit'],
          detentionunit: rotDetails['DetentionUnit'],

          consignments: [], // items pushed in below
          attachments: [], // items pushed in below

          senderconfigcode: loginDetails['ConfigCode'],
          configcode: this.selectedHaulier['API URL'], // changes based on what haulier is chosen
        };

        for (let contIndex = 0; contIndex < rotDetails['ContDetail'].length; contIndex++) {
          // push items into consignments array
          saveHAUBookingRequestBody['consignments'].push({
            seqno: contIndex + 1,
            remarks1:
              rotDetails['ContDetail'][contIndex]['Remarks1'] ? rotDetails['ContDetail'][contIndex]['Remarks1'] : '',
            remarks2: '',
            total_charges: rotDetails['Total Charges'] ? rotDetails['Total Charges'] : '',
            actual_charges: rotDetails['Actual Charges'] ? rotDetails['Actual Charges'] : '',
            cont_no:
              rotDetails['ContDetail'][contIndex]['Cont No'] ? rotDetails['ContDetail'][contIndex]['Cont No'] : '',
            size: rotDetails['ContDetail'][contIndex]['Size'] ? rotDetails['ContDetail'][contIndex]['Size'] : '',
            cont_type:
              rotDetails['ContDetail'][contIndex]['Cont Type'] ? rotDetails['ContDetail'][contIndex]['Cont Type'] : '',
            type: '0',
            deliverytype:
              rotDetails['ContDetail'][contIndex]['Delivery Type'] ?
                rotDetails['ContDetail'][contIndex]['Delivery Type']
              : '',
            handlingtype:
              rotDetails['ContDetail'][contIndex]['Handling Type'] ?
                rotDetails['ContDetail'][contIndex]['Handling Type']
              : '',
            seal_no:
              rotDetails['ContDetail'][contIndex]['Seal No'] ? rotDetails['ContDetail'][contIndex]['Seal No'] : '',
            gweight: rotDetails['ContDetail'][contIndex]['Weight'] ? rotDetails['ContDetail'][contIndex]['Weight'] : '',
            measurement: rotDetails['M3'] ? rotDetails['M3'] : '',
            temperature: rotDetails['Temperature'] ? rotDetails['Temperature'] : '',
            height:
              rotDetails['ContDetail'][contIndex]['ContHeight'] ?
                rotDetails['ContDetail'][contIndex]['ContHeight']
              : '',
            reqtimedesc: rotDetails['Req Time Description'] ? rotDetails['Req Time Description'] : '',
            officehrs: rotDetails['Office Hours'] ? rotDetails['Office Hours'] : '',
            fumigation: rotDetails['Fumigation'] ? rotDetails['Fumigation'] : '',
            contline: rotDetails['Container Line'] ? rotDetails['Container Line'] : '',
            contoperator: rotDetails['Container Operator'] ? rotDetails['Container Operator'] : '',
            commodity:
              rotDetails['ContDetail'][contIndex]['Commodity1'] ?
                rotDetails['ContDetail'][contIndex]['Commodity1']
              : '',
            handlingtypedesc:
              rotDetails['ContDetail'][contIndex]['Handling Type Desc'] ?
                rotDetails['ContDetail'][contIndex]['Handling Type Desc']
              : '',
            deliverytypedesc:
              rotDetails['ContDetail'][contIndex]['Delivery Type Desc'] ?
                rotDetails['ContDetail'][contIndex]['Delivery Type Desc']
              : '',
            offloadatpremis: rotDetails['Offload At Premis'] ? rotDetails['Offload At Premis'] : '',
            securedpremises: rotDetails['Send To Secured'] ? rotDetails['Send To Secured'] : '',
            letterofundertaking: '0',
            rfcofficehrs: rotDetails['RFC Office Hours'] ? rotDetails['RFC Office Hours'] : '',
            otherinstructions: '',
            daterequired:
              rotDetails['Time Required From'] ?
                this.$dateTime.getDateTime(rotDetails['Time Required From'], 'yyyy-MM-dd')
              : '',
            timerequired:
              rotDetails['Time Required From'] ?
                this.$dateTime.getDateTime(rotDetails['Time Required From'], 'HHmm')
              : '',
          });
        }

        const documentGUID = []; // used for UpdateStatusTask call later
        for (const attachment of this.selectedAttachments[rotIndex]) {
          documentGUID.push(attachment['DocumentGUID']);
          const doc = rotDetails['Doc'].filter((doc) => {
            return doc['Document GUID'] == attachment['DocumentGUID'];
          })[0]; // find corresponding doc from rotDetails
          // needed because selectedAttachments only has filename, remarks and GUID
          // file data and file type aren't copied into selectedAttachments to reduce memory usage

          saveHAUBookingRequestBody['attachments'].push({
            doc_code: 'ATT',
            doc_refno: doc['File Name'],
            doc_image: doc['Doc Image'],
            doc_imagetype: doc['File Type'],
            doc_remark: doc['Doc Remark'],
          });
        }

        let eROTJSONFileCount; // for uploading a new JSON file containing SaveHAUBooking's request body later
        if (this.selectedeROT[rotIndex]['eROT Status'] == 'Pending') {
          saveHAUBookingRequestBody['action'] = 'N';
          saveHAUBookingRequestBody['autorequestno'] = '';
          eROTJSONFileCount = 0; // if the selected eROT hasn't been sent before, there won't be any JSON files
        } else {
          saveHAUBookingRequestBody['action'] = 'E';

          try {
            const mostRecenteROTJSONBody = await this.getMostRecenteROTJSONBody(
              rotDetails['Job No'],
              rotDetails['CMR No'],
            ); // get the most recent JSON file

            eROTJSONFileCount = mostRecenteROTJSONBody['JSONCounter'];
            saveHAUBookingRequestBody['autorequestno'] = JSON.parse(atob(mostRecenteROTJSONBody['JSONBody']))[
              'autorequestno'
            ];
          } catch (e) {
            //console.log(e);
          }
        }

        try {
          const saveHAUBookingResponse = await this.$apiCallV2('/ROT/SaveHAUBooking', saveHAUBookingRequestBody); // try to send eROT to haulier
          if (saveHAUBookingResponse[0]['Results'] != 0) {
            // send eROT failed
            this.popupType = 'error';
            this.popupTitle = 'Send eROT failed';
            this.popupContent = `ROT# ${rotDetails['CMR No']}: ${saveHAUBookingResponse[0]['ErrMsg']}`;
            this.showPopup = true;
            this.pageIsLoading = false;
            return;
          }

          // if eROT has been successfully sent, SaveHAUBooking will return a AutoRequestNo. Save this into the JSON file
          saveHAUBookingRequestBody['autorequestno'] = saveHAUBookingResponse[0]['AutoRequestNo'].trim();

          for (let i = 0; i < saveHAUBookingRequestBody['attachments'].length; i++) {
            delete saveHAUBookingRequestBody['attachments'][i]['doc_image']; // remove attachment data from SaveHAUBooking request body, the file already exists in the forwarder's database, no need to store a duplicate
            saveHAUBookingRequestBody['attachments'][i]['doc_GUID'] = documentGUID[i]; // storing the GUID is good enough
          }

          const updateStatusTaskRequestBody = {
            jobNo: rotDetails['Job No'],
            rotNo: rotDetails['CMR No'],
            actstartdate: this.$dateTime.getDateTime(currentDateTime, 'yyyy-MM-dd'), // current date
            actstarttime: this.$dateTime.getDateTime(currentDateTime, 'HHmm'), // current time
            'File Name': `eROT_${rotDetails['CMR No']}_${this.$dateTime.getDateTime(currentDateTime, 'yyyy-MM-dd HHmm')}_${eROTJSONFileCount + 1}.json`,
            'File Type': 'application/json',
            'File Data': btoa(JSON.stringify(saveHAUBookingRequestBody)), // convert SaveHAUBooking's request body into base64
          };

          await this.$apiCallV2('/ROT/UpdateStatusTask', updateStatusTaskRequestBody);
        } catch (e) {
          this.popupType = 'error';
          this.popupTitle = 'Send eROT failed';
          this.popupContent = `Failed to send ROT ${rotDetails['CMR No']}`;
          this.showPopup = true;
          this.pageIsLoading = false;
          //console.log(e);
          return;
        }
      }
      this.pageIsLoading = false;
      this.popupType = 'success';
      this.popupTitle = 'Send eROT success';
      this.popupContent = `Successfully sent ${this.selectedeROTList} to ${this.selectedHaulier['Description']}`;
      this.showPopup = true;
      this.showConfirmationPopup = false;
      this.refreshClicked();
    },
    pdfGenerated: function (_blobLink, blobDetails) {
      // let base64PDF = await this.$convertFile.toBase64(blobDetails);
      if (this.generatePDFResolve) {
        this.generatePDFResolve(blobDetails);
        this.generatePDFResolve = null;
      }
    },
  },

  async mounted() {
    this.pageLoadingText = 'Getting Hauliers';
    this.pageIsLoading = true;

    this.haulierFilterItems = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'HAULIER_EROT' });

    for (const haulier of this.haulierFilterItems) {
      haulier['Haulier Code'] = haulier['Haulier Code'].trim(); // trim trailing whitespace
      if (haulier['Default'])
        // if the default field is set to 1
        this.selectedHaulier = haulier; // assign that haulier as the default
    }
    if (this.selectedHaulier !== null) {
      this.refreshClicked();
    } else {
      this.pageIsLoading = false;
    }
  },
  watch: {
    dateFilterChecked: function (_val) {
      // clear error messages when checked or unchecked
      this.dateFilterStartErrorMessage = '';
      this.dateFilterEndErrorMessage = '';
    },
    searchFilterChecked: function (_val) {
      // clear error messages when checked or unchecked
      this.searchByErrorMessage = '';
      this.searchCriteriaErrorMessage = '';
      this.searchKeywordErrorMessage = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.rotContainer {
  width: 100%;
  height: 100%;
  padding: 8px 10px 8px 42px;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  // border: 1px solid red;
}

.mainContent {
  width: 100%;
  height: 100%;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.filterBar {
  background-color: white;
  display: flex;
  flex-direction: row;
  margin: 0 0 5px 0;
  border-radius: 5px;
  // border: 1px solid red;
}

.statusFilterContainer {
  display: flex;
  flex-direction: row;
  margin: 5px 5px 5px 5px;
  justify-content: right;
  flex: 1.5;
  // border: 1px solid red;
}

.statusFilterButton {
  height: 100px;
  width: 100px;
  border: 1px solid black;
  border-radius: 3px;
  margin: 0 5px 0 5px;
  text-align: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.statusIcon > img {
  height: 30px;
  width: 30px;
  margin: 5px 0 2px 0;
  // border: 1px solid red;
}

.statusLabel {
  font-size: 14px;
  margin: 0 0 3px 0;
  // border: 1px solid red;
}

.statusCounter {
  font-size: 18px;
  // border: 1px solid red;
}

.generalFilterContainer {
  margin: auto 5px auto 5px;
  padding-right: 5px;
  justify-content: right;
  flex: 1.6;
  // border: 1px solid red;
}

.generalFilterContent {
  display: flex;
  justify-content: right;
  margin: 5px 0 5px 0;
  // border: 1px solid red;
}

.changeFilterPopup {
  position: absolute;
  margin-top: 29px;
  height: fit-content;
  width: 320px;
  background-color: white;
  border: 1px solid black;
  border-radius: 3px;
  padding: 5px 10px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.changeFilterPopupItemContainer {
  position: relative;
  width: 100%;
}

.changeFilterPopupItemCheckbox {
  position: absolute;
  width: fit-content;
  top: -5px;
  left: 3%;
  padding: 0 10px;
  background-color: white;
}

.changeFilterPopupItemFields {
  border: 1px solid black;
  border-radius: 5px;
  width: 100%;
  margin: 5px 0 10px 0;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.changeFilterPopupRefreshButton {
  width: 100%;
  text-align: right;
}

.rotTableBoxContainer {
  background-color: white;
  border-radius: 5px;
  padding: 0 5px 5px 5px;
  height: 100%;
  overflow: hidden;
}

.confirmationPopupContainer {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirmationPopup {
  background-color: white;
  // z-index: 99999;
  width: 80%;
  height: 95%;
  position: absolute;
  padding: 5px;
  display: flex;
  flex-direction: column;
  // border: 1px solid red;
}

.summaryHeader {
  margin-bottom: 10px;
  display: block;
  // border: 1px solid red;
}

.rotDetailsContainer {
  margin-bottom: 10px;
  overflow-y: scroll;
  border: 1px solid black;
}

.rotDetails {
  height: auto;
  // border: 1px solid red;
}

.rotDetailsHeader {
  display: flex;
  flex-direction: row;
  border: 1px solid black;
  align-items: flex-start;
}

.rotDetailsHeaderPrintContainer {
  display: flex;
  justify-content: right;
  align-items: center;
  flex: 1;
  align-self: center;
  margin-left: auto;
  // border: 1px solid red;
}

.rotDetailsHeaderPrintButton {
  margin-right: 10px;
}

.rotAttachmentsContainer {
  display: flex;
  flex-direction: row;
  border: 1px solid black;
}

.rotAttachmentsTableBox {
  flex: 5;
  overflow-x: hidden;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.rotAddAttachmentsContainer {
  flex: 2;
  margin: 40px 5px 10px 5px;
  // border: 1px solid black;
}

.rotDetailsSeparator {
  border-top: 2px dashed black;
}

.sendCancelButtonsContainer {
  margin-top: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  // border: 1px solid red;
}

.sendCancelButton {
  margin: 0 5px;
}

.printROTContainer {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.printROT {
  width: 600px;
  border-radius: 4px;
}
</style>
